<template>
    <svg width="24" height="28" viewBox="0 0 24 28" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.9775 11.9164L2.97997 0.675166C1.64677 -0.0742667 -6.10352e-05 0.889188 -6.10352e-05 2.41859V25.4927C-6.10352e-05 27.0418 1.68521 28.0028 3.01843 27.2139L23.016 15.3811C24.3416 14.5967 24.3202 12.6712 22.9775 11.9164Z"/>
    </svg>
</template>